import { useState } from "react";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import EnumReviewStatus from "../../../../utils/enum/EnumReviewStatus";
import { handleErrorMessage, useEffectOnce } from "../../../../utils/Utils";

interface ArticleViewServiceType {
  articleList: any;
  setSelectedArticle: any;
  selectedArtcle: any;
  openDialog: boolean;
  handleOpenDialog: any;
  handleCloseDialog: any;
  articleDialog: any;
  reviewsArticle: any;
  setReviewsArticle: any;
  authData: any;
}

const articleViewStatus = [
  EnumReviewStatus.NEW_ARTICLE,
  EnumReviewStatus.REJECTED,
  EnumReviewStatus.ACCEPTED,
  EnumReviewStatus.REVIEWED,
  EnumReviewStatus.UNDER_REVIEW,
  EnumReviewStatus.REVIEWER_SELECTION,
  EnumReviewStatus.DIRECT_REJECT,
  EnumReviewStatus.REJECTED_R0,
  EnumReviewStatus.DIRECT_REJECT_R0,
  EnumReviewStatus.REJECT_AND_RESUBMIT_AS_A_LETTER_TO_THE_EDITOR,
  EnumReviewStatus.ASSOCIATE_EDITOR,
  EnumReviewStatus.RETURNED_TO_EDITOR,
];

export default function ArticleViewService(): ArticleViewServiceType {
  const { axiosGetMyArticleWithStatus }: ArticleControllerType = ArticleController();
  const { showMessage, setBlockUI, authData } = useAppContext();
  const [articleList, setArticleList] = useState<any>(undefined);
  const [selectedArtcle, setSelectedArticle] = useState<any>();
  const [articleDialog, setArticleDialog] = useState<any>();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [reviewsArticle, setReviewsArticle] = useState<any>();

  useEffectOnce(() => {
    setBlockUI(true);
    axiosGetMyArticleWithStatus(articleViewStatus)
      .then((result: any) => {
        setArticleList(sortArray(result.data));
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      })
      .finally(() => {
        setBlockUI(false);
      });
  });

  const sortArray = (array: any) => {
    return array.sort((a: any, b: any) => b.createDate - a.createDate);
  };

  const handleOpenDialog = (article: any) => {
    setArticleDialog(article);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setArticleDialog(undefined);
  };

  return {
    articleList,
    setSelectedArticle,
    selectedArtcle,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    articleDialog,
    reviewsArticle,
    setReviewsArticle,
    authData,
  };
}

export type { ArticleViewServiceType };
